const initialState = () => ({
  formData: null,
  skillRouting: null,
  completed: false,
  surveyRecordToken: null,
})

export const state = initialState()

export const getters = {
  isShow(state, getters, rootState, rootGetters) {
    return (
      !rootGetters['Widget/isRgpdVisible'] &&
      (rootState.Widget.bot.botPrequalificationActive ||
        rootState.Widget.fullframeOptions.liveChatPrequalificationActive) &&
      !state.completed
    )
  },
}

export const mutations = {
  RESET(state) {
    const newState = initialState()
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key]
    })
  },
  SET_FORM_DATA(state, payload) {
    state.formData = payload
  },
  SET_SKILL_ROUTING(state, payload) {
    state.skillRouting = payload
  },
  SET_COMPLETED(state, payload) {
    state.completed = true
    state.surveyRecordToken = payload
    state.formData = null
  },
}

export const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
